import React from 'react';
import { useSelector } from "react-redux";
export default function ZoomMeeting(props) {
    const hashkey = useSelector(({userInfo}) => userInfo.hashkey) || null;
//    return (<iframe style={{width:"100%", height:"100%", border:"none"}} title="Zoom Player" src={`https://meet.google.com/xtq-jrhe-pze`} />);

    return (<iframe style={{width:"100%", height:"90vh", border:"none"}} title="Zoom Player" src={`/zoom.html?${hashkey}`} />);
}

